import {useRef, useState} from 'react'
import axios from 'axios'
import {noop} from 'lodash'

const useHtmlForm = (url, successCallback = noop) => {
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [hasError, setHasError] = useState(false)
    const formRef = useRef()

    const validate = () => formRef.current.reportValidity()

    const submitAction = () => {
        if (isSubmitting) {
            return
        }
        setHasError(false)
        const formData = new FormData(formRef.current)
        if (validate()) {
            setIsSubmitting(true)
            axios
                .post(url, formData, {
                    headers: {'Content-Type': 'multipart/form-data'},
                })
                .then(({data}) => {
                    setIsSubmitted(true)
                    successCallback(data, formData)
                })
                .catch(() => {
                    setHasError(true)
                })
                .finally(() => {
                    setIsSubmitting(false)
                })
        }
    }

    return {
        formRef: formRef,
        isSubmitted: isSubmitted,
        hasError: hasError,
        submit: submitAction,
    }
}

export default useHtmlForm
